import React, { Fragment } from "react";
import { lazyWithRetry } from "../../core/lazy_with_retry";
import { useI18n } from "../../lib/i18n/i18n_provider";

import { OfferingDetailsDayPassWithCapacity } from "../template_offering_details_daypass_with_capacity";
import { useRoomsAnalytics } from "./rooms_analytics";
import {
  generalInfoEN,
  generalInfoHE,
  testimonials,
  usePartnerConfig,
} from "./rooms_partner_config";

const Theme = lazyWithRetry(() => import("./rooms_theme"));

export function OfferingRoomsDayOffice() {
  useRoomsAnalytics();
  const { locale } = useI18n();
  const partnerConfig = usePartnerConfig();

  return (
    <Fragment>
      <Theme />
      <OfferingDetailsDayPassWithCapacity
        showAddress
        showDirections={false}
        partnerConfig={partnerConfig}
        data={{
          testimonials: testimonials,
          title: "Daily Office",
          generalInfo:
            locale.baseLanguageTag === "he" ? generalInfoHE : generalInfoEN,
        }}
      />
    </Fragment>
  );
}
